/**
 * Sets the background position on the current camera.
 * @param {Object} camera - The current camera being updated.
 * @param {Object} backgroundPosition - The backgroundPosition to apply and calculate with.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateStreetViewUrl(camera, streetViewUrl) {
  return Object.assign({}, camera, { streetViewUrl })
}



// WEBPACK FOOTER //
// ./src/reducers/updateStreetViewUrl.js